export const getAuthorQuestion = () => ({
  name: "Autor raportu",
  comment: "Proszę podać imię i nazwisko",
  required: true,
  type: { label: "Tekst", value: "text" },
  special: "author",
});
